module.exports = __webpack_public_path__ + "static/media/business-river.108ad7a5.png";